module.exports = __webpack_public_path__ + "static/img/spelling-bee.0ef4347e.svg";